import React, {useState, useRef, useEffect} from 'react';

export const LogarithmicRangeInput = ({min, max, value, onChange}) => {
	const logarithmicValue = Math.pow(
		100,
		(Math.log10(max) - Math.log10(min)) * (value / 1000) + Math.log10(min)
	);

	const handleRangeChange = (event) => {
		const scaledValue = parseFloat(event.target.value);
		const logarithmicValue = Math.pow(
			100,
			(Math.log10(max) - Math.log10(min)) * (scaledValue / 1000) + Math.log10(min)
		);
		const rawValue =
			((Math.log10(logarithmicValue) - Math.log10(min)) /
				(Math.log10(max) - Math.log10(min))) *
				(max - min) +
			min;
		onChange(rawValue);
	};

	return (
		<input
			type='range'
			min={0}
			max={1000}
			value={value}
			onChange={handleRangeChange}
		/>
	);
};
